import React from "react"
import { getIn } from "formik"
import FormLabel from "./formLabel"

function FormRadioButton({ ...props }) {
  const { textDesc, form, field } = props

  const errors = getIn(form.errors, field.name)
  const touched = getIn(form.touched, field.name)

  const handleRadioButton = (buttonName, buttonValue) => {
    form.setFieldValue(buttonName, buttonValue)
  }

  return (
    <div className="marginBottom19px">
      <FormLabel text={textDesc} />
      <div className="marginTop10px">
        <div
          className={
            "fontSize18px height50 horizontal-align backgroundGrey cursorPointer borderRadius8 YesNobutton " +
            (field.value ? "tick" : "")
          }
          onClick={() => {
            handleRadioButton(field.name, true)
          }}
          role="button"
          tabIndex="0"
        >
          Yes
        </div>
        <div
          className={
            "fontSize18px height50 horizontal-align backgroundGrey cursorPointer borderRadius8 YesNobutton " +
            (!field.value ? "tick" : "")
          }
          onClick={event => {
            handleRadioButton(field.name, false)
          }}
          role="button"
          tabIndex="0"
        >
          No
        </div>
        {errors && touched && <span className="InputError">{errors}</span>}
      </div>
    </div>
  )
}
export default FormRadioButton
